<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
  
  <div class="d-flex align-items-center">
     <el-form inline ref="form" :model="searchform">
            
      
 <el-button type="danger" size="mini" @click="deleteAll">{{$t('searchText.선택삭제')}}</el-button>
        
          <el-form-item  class="mb-0 mr-0">
             

             <el-date-picker
                  v-model="searchform.time"
                  type="daterange"
                  range-separator="~"
                  :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px">
                </el-date-picker>
          </el-form-item>
          <el-form-item class="mb-0 mr-1">
            <el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button> 
          </el-form-item>
      </el-form>
       
     
    
  
   <el-button type="primary" size="mini" @click="allRead" style="margin-left:20px">{{$t('newAdd.전체읽기')}}</el-button>
 
     
    
      
        

  
  </div>
 
        <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
       border class="mt-2"
       :empty-text="$t('tableText.데이타가없습니다')" @selection-change="handleSelectionChange">
     <el-table-column
      type="selection"
      width="55"
      align="center">
    </el-table-column> 
     <el-table-column width="80" align="center" label="ID">

          <template v-if="loading==false" slot-scope="scope">{{total-(currentPage-1)*50-scope.$index}}</template>
        </el-table-column>
         
    
 
        <el-table-column
        
       :label="$t('msg.내용')" prop="wr_1" align="center">
         <template slot-scope="scope">
              <el-input
            type="textarea"
            :rows="2"
            v-model="scope.row.wr_1" v-on:click.native="readMemo(scope,false)">
          </el-input>
          </template>
      </el-table-column> 

        <el-table-column
        
        :label="$t('msg.확인')" align="center">
         <template slot-scope="scope" v-if="scope.row.read_date==null">
            <el-button type="primary" size="mini" @click="readMemo(scope,true)">{{$t('msg.확인')}}</el-button>
          </template>
      </el-table-column> 

       <el-table-column
        
         :label="$t('tableText.보낸시간')" prop="add_date" align="center" width="300">
        
      </el-table-column> 

      <el-table-column
        
         :label="$t('tableText.읽은시간')" prop="read_date" align="center" >
        
      </el-table-column> 

   

       
  
     
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
          <div style="flex: 1;" class="px-2">
            <el-pagination
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="size"
            layout="prev, pager, next"
            :total="total"
            @size-change="handleSizeChange"
                @current-change="handleCurrentChange">
          </el-pagination>
          </div>
        </el-footer>  
      
  
        <el-dialog
          :close-on-click-modal ="false"
          :title="$t('searchText.쪽지보내기')"
          :visible.sync="creatModel" class="qaDialogS">
          <div class="d-flex" v-loading="qaLoading">
          <div style="width:70%">
          <el-form ref="form" :model="form" label-width="10px" v-loading="loading" :rules="rules">
            
            <el-form-item :label="$t('nav.아이디')" prop="mem_id">
              <el-input v-model="form.mem_id"></el-input>
            </el-form-item>
            <el-form-item :label="$t('msg.레벨')">
               <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange" style="margin-right: 10px;">ALL</el-checkbox>
                  <div style="margin: 15px 0;"></div>
                  <el-checkbox-group v-model="level" @change="handlelevelChange">
                    <el-checkbox v-for="checkboxs in cities" :label="checkboxs" :key="checkboxs" style="margin-right: 10px;">{{checkboxs}}</el-checkbox>
                  </el-checkbox-group>
            </el-form-item>
           <el-form-item :label="$t('msg.내용')" prop="content">
               <el-input
                type="textarea"
                :rows="8"
                v-model="form.wr_1">
              </el-input>
          </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
             <el-button @click="creatModel = false" style="float:right;">{{$t('msg.취소')}}</el-button>
            <el-button type="primary" @click="memoSend()" style="float:right;" class="mr-2">{{$t('msg.확인')}}</el-button>
          </span>
        </div>
        <div class="border ml-auto p-2 d-flex" style="width:29%;height:350px;overflow-y:auto;flex-direction:column;align-items:start">
            <el-button type="text" v-for="(item,index) in qa" :key="index"  class="py-2 ml-0" @click="qaChange(index)">{{item.title}}</el-button>
          
          </div>
      </div>
        
       
       
        </el-dialog>
       
        <el-dialog
  :close-on-click-modal="false"
  :title="$t('newAdd.쪽지내용')"
  :visible.sync="creatModel2"
  class="qaDialogSsMemo"
  :width="memoWidth"
>
  <el-form
    ref="form"
    :model="form"
    label-width="100px"
    class="form_application"
    v-loading="memoLoading"
  >
    <div class="propreinfor" style="border-top: 1px solid rgb(192, 196, 204);">
      
      <el-form-item :label="$t('msg.내용')" prop="content" class="mb-0">
        <el-input
          type="textarea"
          v-model="form.wr_1"
          :rows="18"
          resize="none"
          style="width: 100%;"
        />
      </el-form-item>

    </div>
  </el-form>

  <span slot="footer" class="dialog-footer">
    <el-button @click="submit" style="float:right;">
      {{$t('msg.닫기')}}
    </el-button>
  </span>
</el-dialog>


         <div class="dialogLayer" v-show="shareShow" @click="shareShow=!shareShow"></div>
        
</div>
 </template>

 <script>
  import layer from '../../components/common/layer.vue';
  import layerNew from '../../components/common/layer-new.vue';
 const checkboxsOptions = ['0', '1', '2', '3', '4', '5', '6', '7'];

    export default {
    components: {
      layer,layerNew
    },
      data(){
        return{
          memoWidth:'650px',
          qaWidth:'500px',
          activeName: 'first',
          tapidx:"0",
          qa:[],
          otp:'',
          creatModel2:false,
          memoLoading:false,
          qaLoading:false,
          creatModel1:false,
          shareShow:false,
            level_title:{
              '-2':this.$i18n.t("msg.블랙"),
              '-1':this.$i18n.t("msg.대기"),
              '0':this.$i18n.t("msg.기본")               
            },
          formLoading:false,
          idDialogVisible: false,
          admin_id:window.sessionStorage.getItem('admin_id'),
          domain:window.sessionStorage.getItem('domain'),
             sitetype:window.sessionStorage.getItem('sitetype'),
               bg:window.sessionStorage.getItem('bg'),
               new:window.sessionStorage.getItem('new'),
          form:{
            mem_id:'',
            idx:'',
            content:'',
            wr_1:'',
          },
         checkAll: false,
         level: [],
         cities: checkboxsOptions,
        isIndeterminate: true,
          
          searchform:{
            keyword:'',
            time:[],
              searchOptions1:[
            {
              label:this.$i18n.t("msg.전체"),
              value:''
            },
              {
              label:this.$i18n.t("msg.회원"),
              value:'user'
            },
             {
              label:this.$i18n.t("msg.파트너"),
              value:'pt'
            }

            ],
            value1:'',
            searchOptions:[
                
            {
              label:this.$i18n.t("msg.아이디"),
              value:'attn'
            },
            
           

            ],
           
            
            value:'',

      


          },
           pickerOptions: {
          },
         shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
    
       
          
            
        
             total:0,
             size:0,
             loading: false,
             editIndex:-1,
             creatModel:false,
             tableData: [],
               currentPage:1,
               multipleSelection:[],
               rules: {
                  
                  wr_1:[{ required: true, message: '', trigger: 'blur'}],
                },
              
              
               
       
          }
          
          
        },
        created() {
          

          this.getList(true);
          
      
    },
   
      methods:{
       
        editWr(e){

                 
          let token=window.sessionStorage.getItem('user');
          this.qaLoading = true
        
            this.$axios({
                  method:'get',
                  url:this.domain+'/user/memo?idx='+e.row.idx,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
 
            }).then((response) =>{ 
             //  console.log('data====',response.data.auto_qa)
                  let item = response.data.data 
                  this.form ={
                    idx: item.idx,
                   
                    wr_1 : item.wr_1,
                  
                  }
                  this.qa = response.data.auto_qa
                  this.qaLoading = false    
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })
             
          this.creatModel1 = true

        },
        qaChange(index){
          //console.log(index)
         
         
          this.form.wr_1 = this.qa[index].contents

        },
         // 关闭弹框（头部的X）
        
        handleClose () {
               this.idDialogVisible = false
            },
        cancelData(){
          this.idDialogVisible = false
        },
        cancelEvent(){
          this.shareShow = false
        },
       openModel(id,e){

          this.shareShow = true
                let pix=window.screen.width;
           
                let width='1200px';
                if(pix<1200)
                {
                  width='95%';
                }

                this.$layer.iframe({
                type: 2,
                title: id,
                content: {
                    content: layerNew,
                    parent: this,
                    data:{
                    info:{id:id},
                    activeTab:e,
                    model:this.shareShow,
                    layerid:'id'
                    }
                  
                },
              
                shadeClose: true,
                maxmin:true,
                shade: false,
                area: [width+'', '740px'],
                cancel:()=>{
                  this.shareShow = false
                  console.log(close)
                }
                
             
             });

              return;
        },
         readMemo(e,load){
           let token=window.sessionStorage.getItem('user');

           

            this.form ={
                    idx: '',
                    wr_1 : '',
                  
                  }

        this.memoLoading = true
            this.$axios({
                  method:'get',
                  url:this.domain+'/user/memo?idx='+e.row.idx,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
 
            }).then((response) =>{ 
             //  console.log('data====',response.data.auto_qa)
                  let item = response.data.data 
                  this.form ={
                    idx: item.idx,
                    wr_1 : item.wr_1,
                  
                  }

                  this.getList(load);
                  this.memoLoading = false
               
            }).catch((error) =>{
                 this.memoLoading = false
            })
             
          this.creatModel2 = true
                    
          
        },
        submit(){

                          //关闭
              this.creatModel2 = false
              
                
        },
       
         handleCheckAllChange(val) {
            this.level = val ? checkboxsOptions : [];
            this.isIndeterminate = false;
          },
          handlelevelChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.cities.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
          },
           // 搜索事件
      searchEvent(){

                if(this.searchform.keyword!='' && this.searchform.value == ''){
                  this.$message(this.$i18n.t("msg.검색타이틀선택하세요"));
                   return;
                }

              
            this.currentPage=1;


          this.getList(true);
          
             

        },
         handleSizeChange(val) {
              //console.log(`每页 ${val} 条`);
              this.size = val
              this.getList(true);
              this.loading= true

            },
            handleCurrentChange(val) {
              //console.log(`当前页: ${val}`);
              this.currentPage = val
              this.getList(true);
              this.loading= true
            },
           handleSelectionChange(val) {
          //console.log(val)
                this.multipleSelection = val;

      },
       // 批量删除
      deleteAll(){
        this.$confirm(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
         confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {
          let token=window.sessionStorage.getItem('user');

          //console.log('hh',this.multipleSelection);

                    let newids=[];

           this.multipleSelection.forEach(item=>{
            
            //console.log('id',item.id);
            newids.push(item.idx);
           });

           console.log('newids',newids);

          this.$axios({
                      method:'post',
                       data:{idx:newids,opt:this.otp},
                      url:this.domain+'/user/memo_del',
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
                    this.getList(true)
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          })

        
      },  
      allRead(){
          this.$confirm(this.$i18n.t("newAdd.전체읽기하시겠습니까"), this.$i18n.t("msg.알림"), {
         confirmButtonText: this.$i18n.t("msg.확인"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {
          let token=window.sessionStorage.getItem('user');

          this.$axios({
                      method:'post',
                      
                      url:this.domain+'/user/all_read',
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
                    this.getList(true)
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          })
      },
        getList(load){

        
          let s_time="";
          let e_time="";

          if(this.searchform.time.length>0)
          {
              s_time=this.searchform.time[0];
              e_time=this.searchform.time[1];
          }

          if(load)
          {
               this.loading = true
          }
              
         

           let token=window.sessionStorage.getItem('user');
            //console.log(token);
           let urls=this.domain+'/user/memolist?type='+this.tapidx+'&post='+this.searchform.value1+'&s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword+'&page='+this.currentPage;

          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                     //console.log('data=',response.data.data.data)
                     let data = response.data.data
                     this.tableData =data.data
                     this.total = data.total
                     this.currentPage = data.current_page
                     this.size =data.per_page
                     
                     this.loading =false
               
            }).catch((error) =>{
            
               this.$message.error(error);
               this.loading = false
                //console.log('error',error.response)       //请求失败返回的数据
               
            })
        },

        
        
      
        
      }
  }
</script>

 <style scoped>
pre {
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
}

.bg-danger{
  background-color:#72e8ff!important
 }
.bg-primary{
  background-color:#9dcdff!important
}
.bg-yellow {
    background-color: #f3ff77!important;
}
/deep/ .el-select-dropdown__item.selected{
  color:#000
}
/deep/ .el-input__inner{
  background:transparent;
  border:1px solid #cfcfcf;
  border-radius:2px;
}
/deep/ .el-dialog__body{
  padding:10px 20px;
}
/deep/ .el-form-item {
  margin-bottom:10px;
}

/deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 /deep/ .el-dialog__body{
  padding:10px 20px
 }
 >>>.el-dialog__footer{
  padding-top:0
 }
 .form_application{
 
}
.form_application .propreinfor {
         border-left: 1px solid rgb(192, 196, 204);
      
        margin: 0 auto;
        position:relative;


}
.form_application .contant {
       width:100%;
        padding:5px;
        border-right: 1px solid rgb(192, 196, 204);
        border-bottom: 1px solid rgb(192, 196, 204);
        height: 100% !important;

}
>>>.el-form-item__label {
        
       position:absolute;
       margin:0px;
        border-right: 1px solid rgb(192, 196, 204);
        border-bottom: 1px solid rgb(192, 196, 204);
        padding: 10px;
        background: #f9f9f9;
        font-weight: 400;
        color: #000;
        line-height: normal;
        display: flex;
        align-items: center;
        justify-content: center;
          height: 100% !important;

      }
      >>>.bluecolor .el-input__inner,>>>.bluecolor .el-textarea__inner{
        color:#333 !important;font-weight:bold
      }

</style>


// WEBPACK FOOTER //
// src/views/memo/list.vue